module.exports = __webpack_public_path__ + "static/media/guide-line-12.2283f935.svg";